const nameformat = (name) => {
    if (!name) return '';

    if (name.length < 2) return name;

    let nameInit = name[0].toUpperCase();
    const nameSplit = name.split(' ');

    if (nameSplit.length > 1) {
        nameInit += nameSplit[1].trimStart()[0].toUpperCase();
    }

    return nameInit;
};

export default nameformat;
